import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateAgo',
    pure: true
})
export class DateAgoPipe implements PipeTransform {

  transform(value: string | number | Date | null | undefined): string | number | Date | null | undefined {
    if (!value) {
      return value;
    }
    const seconds = Math.floor((Date.now() - new Date(value).getTime()) / 1000);
    if (seconds < 60) {
      return 'Just now';
    }
    const intervals = {
      year: 365 * 24 * 60 * 60,
      month: (52 * 7 * 24 * 60 * 60) / 12,
      week: 7 * 24 * 60 * 60,
      day: 24 * 60 * 60,
      hour: 60 * 60,
      minute: 60,
      second: 1
    };
    for (const [unit, size] of Object.entries(intervals)) {
      const counter = Math.floor(seconds / size);
      if (counter > 0) {
        return counter === 1 ? `a ${unit} ago` : `${counter} ${unit}s ago`;
      }
    }
    return value;
  }


}
